import React from 'react'
import PropTypes from 'prop-types'
export default function InputRadioSelect(props) {
    const {
        onChange,
        type = 'checkbox',
        groupName,
        propid
    } = props
    let { groupList } = props
    const handleCheckGroupChange = (event, index, model) => {
      const options = [...groupList]
        options.forEach((prop, ind) => {
            if (ind === index) {
                prop.selected = event.target.checked
            }
        })
        groupList = [...options]
        if (onChange) {
          onChange(model)
        }
    }
    const handleRadioGroupChange = (event, index, model) => {
      const options = [...groupList]
        options.forEach((prop, ind) => {
          prop.isChanged = true
            if (ind === index) {
                prop.selected = event.target.checked
            } else {
                prop.selected = false
            }
        })
       groupList = [...options]
        if (onChange) {
          onChange(model)
        }
    }

    return (<>
        {groupList.map((option, index) => {
            const fieldProps = {
                id: option.key,
                name: type === 'checkbox' ? option.key : groupName,
                type,
                value: option.selected,
                propid,
                'data-testid': `${type}-${option.key}`,
                onChange: event => {
                    return (type === 'checkbox' ? handleCheckGroupChange(event, index, props) : handleRadioGroupChange(event, index, props))
                },
                checked: option.selected
            }
            // if (option.selected) {
            //     fieldProps.checked = option.selected
            // }

            return (
                type === 'checkbox' ? (<div className="col ml-2" key={`group${index}`}>
                    <input {...fieldProps} />
                    <label htmlFor={option.key} className="col-form-label ml-2"> {option.val}</label>
                </div>) :
                    (<div className="col ml-2" key={`group${index}`}>
                        <input {...fieldProps} />
                        <label htmlFor={option.key} className="col-form-label ml-2"> {option.val}</label>
                    </div>)
            )
        })}
    </>
    )
}

InputRadioSelect.propTypes = {
  propid: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  groupName: PropTypes.string,
  groupList: PropTypes.array
}


